import { createContext, useContext } from "react";

/**
 * Collab-editing context for a live published page.
 *
 * Provided by the host page (PublishedPageV3) when the tenant has
 * _ContentCollabEditingMode enabled AND the doc has an active collab
 * session. ViewBlockGenerator consumes it to derive per-block editability:
 *
 *   readOnly = !inCollabMode || !canEdit || !editableBlock || lockedByOther
 *
 * Shape: {
 *   canEdit,                    // user has PUBLISH/MODERATE on this contentType
 *   socketId,                   // our connection id — locks matching it are ours
 *   locks,                      // { [valuePath]: { userId, userName, socketId } }
 *   setField(valuePath, value), // live op → Y.Map → peers + debounced flush
 *   acquireLock(valuePath),     // on field focus
 *   releaseLock(valuePath),     // on field blur → triggers session side effects
 * }
 *
 * null everywhere collab isn't active — every consumer must handle that.
 */
export const CollabEditContext = createContext(null);

export const useCollabEditContext = () => useContext(CollabEditContext);
